var generateStyle = function generateStyle(componentTheme) {
  return {
    blankText: {
      margin: "".concat(componentTheme.blankTextMargin, " 0"),
      display: 'flex',
      alignItems: 'center'
    },
    mainWrapper: {
      display: 'flex',
      flexDirection: 'column'
    },
    numCircle: {
      borderRadius: '0.8em',
      border: "".concat(componentTheme.numCircleBorderWidth, " solid ").concat(componentTheme.numCircleBorderColor),
      color: componentTheme.numCircleColor,
      display: 'inline-block',
      lineHeight: '1.6em',
      marginRight: componentTheme.numCircleMargin,
      textAlign: 'center',
      width: '1.6em'
    },
    selectWrapper: {
      flex: 1,
      paddingRight: componentTheme.selectWrapperPadding
    },
    answerTypeWrapper: {
      flex: 2
    },
    optionsWrapper: {
      display: 'flex',
      marginBottom: componentTheme.optionsWrapperMargin
    }
  };
};
export default generateStyle;